import { useTranslation } from "react-i18next";

export default function WaaromWij() {
  const { t } = useTranslation("schuifpui-reparatie");
  const reasons = t("waarom.reasons", { returnObjects: true }) as Array<{
    nr: string;
    title: string;
    desc: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("waarom.h2")}
        </h2>

        <div className="max-w-[900px] mx-auto flex flex-col gap-8 md:gap-12">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="flex flex-col sm:flex-row items-start gap-4 md:gap-8"
            >
              <span className="font-geist-mono font-bold text-6xl md:text-8xl lg:text-[200px] text-brand-yellow leading-none select-none">
                {reason.nr}
              </span>
              <div className="flex-1 pt-1 md:pt-4">
                <h3 className="font-geist font-bold text-lg md:text-xl text-brand-text mb-1.5 md:mb-2">
                  {reason.title}
                </h3>
                <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
                  {reason.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}